module.exports = {"pathContext":{"name":"EncounterSectionDatum","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"encounter","type":{"kind":"OBJECT","name":"Encounter","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/object-encounter-section-datum.json
// module id = 1771
// module chunks = 61585639395791